import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getConfiguracionTBAI (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getConfiguracionTBAI.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/ticketbai/getEmpresaTBAI',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getConfiguracionTBAI }
